<template>
  <div>
    <PCNavbar selectIndex="13"/>
    <MobileNavBar :currentActive="12" />
    <energyCategory/>
    <router-view></router-view>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import energyCategory from '@/components/service_energy_category-2'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    energyCategory
  },
}
</script>

<style>
.el-timeline-item__timestamp{
  font-size: 0.9rem !important;
  padding: 1rem 0;
}
</style>